import React from "react";
import { Card } from "antd";

const TooltipCard = ({ label, icon, message }) => (
  <div
    style={{
      backgroundColor: "#1D2540",
      borderRadius: "8px",
      overflow: "hidden",
      width: "256px",
      padding: "0",
    }}
  >
    <Card
      bordered={false}
      title={<span className="break-word">{label}</span>}
      extra={icon}
      headStyle={{
        borderBottom: "none",
        backgroundColor: "#1D2540",
        padding: "16px 16px 8px 16px",
        color: "white",
      }}
      bodyStyle={{
        backgroundColor: "#1D2540",
        color: "white",
        padding: "0px 16px 16px 16px",
      }}
    >
      <div>
        {message?.map((para, idx) => (
          <p key={idx} className="body-2-large-Tooltip" style={{ marginBottom: "12px" }}>
            {para}
          </p>
        ))}
      </div>
    </Card>
  </div>
);

export default TooltipCard;
